import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://esaifullina.com';
const DEFAULT_IMAGE = `${SITE_URL}/preview_image.png`;

const Seo = ({ title, description, path = '/', image = DEFAULT_IMAGE }) => {
    const url = `${SITE_URL}${path}`;
    return (
        <Helmet defer={false}>
            <title>{title}</title>
            <meta name='description' content={description} />
            <link rel='canonical' href={url} />

            {/* Open Graph */}
            <meta property='og:type' content='website' />
            <meta property='og:title' content={title} />
            <meta property='og:description' content={description} />
            <meta property='og:url' content={url} />
            <meta property='og:image' content={image} />

            {/* Twitter / X */}
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={title} />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:image' content={image} />
        </Helmet>
    );
};

export default Seo;
